import ListItem from "@mui/material/ListItem";
import Box from "@mui/material/Box";

interface ExtendedListItemProps {
  start?: boolean;
  end?: boolean;
  children?: React.ReactNode;
}

const ExtendedListItem: React.FC<ExtendedListItemProps> = ({
  start,
  end,
  children,
}) => {
  return (
    <ListItem disablePadding>
      <Box
        sx={{
          border: "1px solid #D0D1D3",
          borderRadius: "8px",
          margin: 0,
          marginTop: start ? 0 : 2,
          width: "100%",
        }}
      >
        {children}
      </Box>
    </ListItem>
  );
};

export default ExtendedListItem;
